module.exports = __webpack_public_path__ + "static/img/leftbg.9e259d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leftbg.png
// module id = Be7A
// module chunks = 1